import React from 'react';
import WorkerNavBar from '../../Components/NavigationBar/WorkerNavBar';
import PasswordChange from '../../Components/Common/PasswordChange';
import Box from '@mui/material/Box';


const WorkerProfile = () => {
    return (
        <WorkerNavBar>
             <Box sx={{ width: '100%' }}>
         {/* <PasswordChange></PasswordChange> */}
         </Box>
      </WorkerNavBar>
      );
};

export default WorkerProfile;